import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService, Constants, CredentialsService, resStatus } from '@app/core';
import { ReservationService } from '../../reservation.service';
import { of, Subject } from 'rxjs';
import { DxSchedulerComponent } from 'devextreme-angular/ui/scheduler';
import { subDays, addDays, isSameDay } from 'date-fns';
import moment from 'moment';
import { ThemeService } from '@app/shell/theme.service';
moment.locale('de');

@Component({
  selector: 'app-occupancy-index',
  templateUrl: './occupancy-index.component.html',
  styleUrls: ['./occupancy-index.component.scss']
})
export class OccupancyIndexComponent implements OnInit, OnDestroy {
  userClients: any[] = [];
  loadingReservationList: boolean;
  clientReservations: { [key: string]: { reservations: any[]; clientInfo: any } } = {}; // Reservas por cliente
  reservations: any = [];
  currentDate: Date = new Date();
  activeTheme: string;
  private ngUnsubscribe: Subject<any> = new Subject();

  readonly LAYOUT = {
    XXS: 450,
    XS: 768,
    SM: 992,
    MD: 1200,
    LG: 1600,
    XL: 1920,
    XXL: 2560
  };
  layout: number = this.LAYOUT.MD;

  constructor(
    private reservationService: ReservationService,
    private authService: AuthenticationService,
    private themeService: ThemeService
  ) {
    this.themeService.activeTheme$.subscribe((theme: any) => {
      this.activeTheme = theme;
    });
  }

  async ngOnInit() {
    this.authService
      .getActiveClient()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((clientData: any) => {});
    try {
      this.getUserClients();
    } catch (error) {
      console.error('Error initializing the component:', error);
    }
  }

  getUserClients() {
    const clientsObservable = this.authService.getClients(false) || of({ clients: [] });

    clientsObservable.subscribe(
      res => {
        if (res && res.clients) {
          this.userClients = res.clients;
          this.loadReservations();
        } else {
          console.warn('No clients were found.');
        }
      },
      error => {
        console.error('Error retrieving the clients:', error);
      }
    );
  }

  async loadReservations() {
    for (const client of this.userClients) {
      await this.getAllReservations(client.id);
    }
  }

  async getAllReservations(clientId: string | number) {
    this.loadingReservationList = true;

    if (!this.clientReservations[clientId]) {
      this.clientReservations[clientId] = {
        reservations: [],
        clientInfo: this.userClients.find(client => client.id === clientId) || {}
      };
    }
    await this.reservationService
      .getAllReservationsBookByCustomClient(this.currentDate, this.currentDate, clientId)
      .toPromise()
      .then(async (data: any) => {
        if (data) {
          this.clientReservations[clientId].reservations = data.reservations;
          await new Promise<void>(resolve => {
            resolve();
          });
          this.loadingReservationList = false;
        } else {
        }
      });
  }

  today() {
    this.currentDate = new Date();
    this.changeDate();
  }
  prevDay() {
    this.currentDate = subDays(this.currentDate, 1);
    this.changeDate();
  }
  nextDay() {
    this.currentDate = addDays(this.currentDate, 1);
    this.changeDate();
  }
  ngOnDestroy(): any {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  async changeDate() {
    for (const client of this.userClients) {
      this.clientReservations[client.id].reservations = [];
      await this.getAllReservations(client.id);
    }
  }

  isToday() {
    return isSameDay(new Date(), this.currentDate);
  }
}
